import CoreuiController from "../lib/coreui-controller"
import MultiSelect from "../coreui/multi-select"

export default class CoreuiMultiSelectController extends CoreuiController {
  static Component = MultiSelect
}
